(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["useit-header"]) return;
  try {
    
  class UseitHeader extends HTMLElement{
    connectedCallback(){
      const burger=this.querySelector('[data-useit-drawer-open]');
      const drawer=this.querySelector('[data-useit-drawer]');
      const overlay=this.querySelector('[data-useit-drawer-overlay]');
      const closeBtn=this.querySelector('[data-useit-drawer-close]');

      // portal: move drawer/overlay pro body pra escapar de qualquer stacking-context/containing-block do header
      if(drawer && drawer.parentElement!==document.body)document.body.appendChild(drawer);
      if(overlay && overlay.parentElement!==document.body)document.body.appendChild(overlay);

      const open=()=>{
        if(!drawer)return;
        overlay.hidden=false;
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        drawer.setAttribute('aria-hidden','false');
        if(burger)burger.setAttribute('aria-expanded','true');
        document.body.style.overflow='hidden';
      };
      const close=()=>{
        if(!drawer)return;
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        drawer.setAttribute('aria-hidden','true');
        if(burger)burger.setAttribute('aria-expanded','false');
        document.body.style.overflow='';
        setTimeout(()=>{ overlay.hidden=true; },300);
      };

      if(burger)burger.addEventListener('click',open);
      if(closeBtn)closeBtn.addEventListener('click',close);
      if(overlay)overlay.addEventListener('click',close);
      document.addEventListener('keydown',(e)=>{ if(e.key==='Escape'&&drawer&&drawer.classList.contains('is-open'))close(); });

      // accordions (chevron) - abre/fecha com max-height medido
      drawer.querySelectorAll('[data-acc]').forEach((acc)=>{
        const toggle=acc.querySelector('[data-acc-toggle]');
        const body=acc.querySelector('[data-acc-body]');
        if(!toggle||!body)return;
        toggle.addEventListener('click',()=>{
          const isOpen=acc.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded',isOpen?'true':'false');
          body.style.maxHeight=isOpen?(body.querySelector('.useit-drawer-acc-inner').scrollHeight+'px'):'0px';
        });
      });
    }
  }
  if(!customElements.get('useit-header'))customElements.define('useit-header',UseitHeader);

  } catch(e) { console.error(e); }
})();
})();
